import { useEffect, useState } from "react";
import {
  Box,
  BoxProps,
  Button,
  Flex,
  HStack,
  Icon,
  IconButton,
  Text,
} from "@chakra-ui/react";
import { Link, useNavigate } from "react-router-dom";
import { useReactiveVar } from "@apollo/client";
import { userDetailsVar } from "../../lib/cache";
import { UserType } from "../../graphql/generated";
import { GrAddCircle, GrAdd } from "react-icons/gr";
// import { GoDashboard } from "react-icons/go";
// import { IoIosArrowRoundBack } from "react-icons/io";


export const SegmentHomeHeader = (props: BoxProps) => {
  const [userDisplay, setUserDisplay] = useState<UserType | null>(null);
  const currentUser = useReactiveVar(userDetailsVar);
  const navigate = useNavigate();


  useEffect(() => {
    setUserDisplay(currentUser);
  }, [currentUser]);

  if (!userDisplay) {
    return <></>;
  }

  return (
    <Flex
      justifyContent={"space-between"}
      align={"center"}
      mb={[3, null, null, 5, null]}
      minW={"100%"}
      {...props}
    >
      <HStack>
        {(userDisplay?.isStaff ||
          userDisplay?.agency?.partner) && (
          <Box as={"button"} onClick={() => navigate("./")} mr={2}>
            <HStack
              spacing={1}
              _hover={{
                stroke: "primary.darker",
                color: "primary.darker",
              }}
              align={"center"}
            >
              {/* <Icon
                as={IoIosArrowRoundBack}
                width={6}
                height={6}
                strokeWidth={10}
              />
              <Text fontSize={"sm"}>
                Back */}
                {/* {currentUser?.isStaff ? "Back to Campaigns" : "Back to Your Campaigns"} */}
              {/* </Text> */}
            </HStack>
          </Box>
        )}
        <Text fontWeight={"medium"} fontSize={["2xl", null, null, "2xl", null]}>
          Segments
        </Text>
      </HStack>
      <HStack>
        <Link to={"new"}>
          <IconButton
            aria-label={"link to new segment form"}
            icon={<GrAdd />}
            variant={"primary"}
            display={["flex", null, "none", null, null]}
          />

          <Button
            variant={"blueButton"}
            size={"sm"}
            leftIcon={<Icon as={GrAddCircle} />}
            display={["none", null, "flex", null, null]}
          >
            New Segment
          </Button>
        </Link>
      </HStack>
    </Flex>
  );
};
